@if (visible()) {
<div class="fixed inset-0 z-[100] flex items-center justify-center p-4">
  <div class="absolute inset-0 bg-slate-900/40 backdrop-blur-sm transition-opacity" (click)="cancelled.emit()"></div>
  <div
    class="relative bg-white rounded-xl shadow-2xl border border-slate-300/50 max-w-[500px] w-full p-10 animate-in fade-in zoom-in duration-200">
    <div class="mb-10">
      <p class="text-[15px] text-slate-700 font-medium">
        {{ message() }}
      </p>
    </div>

    <div class="flex justify-end gap-4">
      <button #confirmBtn (click)="confirmed.emit()"
        class="min-w-[60px] px-6 py-2.5 bg-gradient-primary text-white text-[13px] font-bold rounded-xl hover:scale-105 transition-all shadow-md active:scale-95">
        {{ confirmLabel() }}
      </button>
      <button #cancelBtn (click)="cancelled.emit()"
        class="min-w-[60px] px-6 py-2.5 bg-gradient-primary text-white text-[13px] font-bold rounded-xl hover:scale-105 transition-all shadow-md active:scale-95">
        {{ cancelLabel() }}
      </button>
    </div>
  </div>
</div>
}
